// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "ebh_swup_page_load", inline: true, disabled: false };
// const loggerMsgs = {};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function ebh_swup_page_load(ARGS) {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { to: targetPageData, _name } = ARGS;
  this.logger("eventbus call", [_name, ARGS], "event", { ...logArgs, inline: false });

  ///// Active page state updt. //////
  ////////////////////////////////////

  const { url } = targetPageData;
  const newActivePage = url === "/" ? "home" : url.replace(/^\//, "");
  this.setState({ activePage: newActivePage });
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
